// admin-allathletes.component.ts

import {Component, Injector, OnInit, ViewChild} from '@angular/core';
import {TableComponent} from '../ui/table/table.component';
import {Company} from '../../models/company';
import {CompanyService} from '../../services/company/company.service';
import {AthleteService} from '../../services/athlete/athlete.service';
import {IDropdownSettings} from 'ng-multiselect-dropdown';
import Swal from "sweetalert2";
import {BaseComponent} from '../base/base.component';

@Component({
    selector: 'app-admin-allathletes',
    templateUrl: './admin-allathletes.component.html',
    styleUrls: ['./admin-allathletes.component.scss']
})
export class AdminAllAthletesComponent extends BaseComponent implements OnInit {
    @ViewChild('athletesTable') athletesTable: TableComponent | undefined;

    userFilter: string = '';
    athleteFilter: string = '';
    parentFilter: string = '';
    companies: Company[] = [];
    selectedCompanies: Company[] = [];
    usersDropdownSettings: IDropdownSettings = {};

    constructor(private companyService: CompanyService, private athleteService: AthleteService, private injectService: Injector) {
        super(injectService);
    }

    async ngOnInit() {
        await this.loadCompanies();

        this.usersDropdownSettings = {
            singleSelection: true,
            idField: 'id',
            textField: 'name',
            allowSearchFilter: true,
            closeDropDownOnSelection: true,
            clearSearchFilter: true
        };

        await this.filterSearch();
    }

    async loadCompanies() {
        this.companies = await this.companyService.getCompanies({$orderby: 'name asc'});
    }

    resetFilters() {
        this.userFilter = '';
        this.athleteFilter = '';
        this.parentFilter = '';
        this.selectedCompanies = [];

        void this.filterSearch();
    }

    async filterSearch() {
        const params: any = {};

        if (this.userFilter.trim() !== '') {
            params['userText'] = this.userFilter.trim();
        }
        if (this.athleteFilter.trim() !== '') {
            params['athleteText'] = this.athleteFilter.trim();
        }
        if (this.parentFilter.trim() !== '') {
            params['parentText'] = this.parentFilter.trim();
        }
        if (this.selectedCompanies.length > 0) {
            params['companyId'] = this.selectedCompanies[0].id;
        }

        this.athletesTable?.loadData(
            `/getCompleteAthlete`,
            params,
            (item: any) => item,
            true
        );
    }

    async deleteAtlete(athleteId: string) {
        Swal.fire({
            icon: "question",
            title: "Sei sicuro di voler eliminare l'atleta?",
            showCancelButton: true,
            confirmButtonText: 'Si, procedi',
            cancelButtonText: "Annulla l'operazione"
        }).then(async (result) => {
            if (result.isConfirmed) {
                this.showSpinner();
                let athleteResponse = await this.athleteService.deleteAthlete(athleteId);
                this.hideSpinner();
                if (athleteResponse.success) {
                    Swal.fire({
                        icon: 'success',
                        title: 'Atleta eliminato con successo'
                    })
                    this.filterSearch();
                } else {
                    Swal.fire({
                        icon: 'error',
                        title: "Errore nell'eliminazione dell'atleta"
                    })
                }
            }
        });
    }
}
